import styled from "@emotion/styled/macro";
import { tokens, Typography } from "@sunrun/experience-ui-components";

const TREE_REMOVAL_MESSAGE =
  "This offer assumes trees have been/will be removed";
const EXISTING_TREES_LABEL = "Existing trees";
const REMOVED_TREES_LABEL = "Trees removed/will remove";

const TreeRemovalLegend = ({ className }: { className?: string }) => (
  <LegendBar className={className} data-testid="tree-removal-legend">
    <Typography size={12} fontWeight="medium" color={tokens.WHITE}>
      {TREE_REMOVAL_MESSAGE}
    </Typography>
    <LegendKey>
      <LegendItem>
        <ExistingTreeDot />
        <Typography size={12} color={tokens.WHITE}>
          {EXISTING_TREES_LABEL}
        </Typography>
      </LegendItem>
      <LegendItem>
        <RemovedTreeDot />
        <Typography size={12} color={tokens.WHITE}>
          {REMOVED_TREES_LABEL}
        </Typography>
      </LegendItem>
    </LegendKey>
  </LegendBar>
);

const LegendBar = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 4px 16px;
  padding: 12px 16px;
  background-color: ${tokens.BRAND_HERO_BLUE};
  border-radius: 10px 10px 0 0;
`;

const LegendKey = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

const LegendItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

const LegendDot = styled.span`
  flex: none;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border-style: solid;
  border-width: 2px;
  box-sizing: border-box;
`;

const ExistingTreeDot = styled(LegendDot)`
  background-color: ${tokens.SUCCESS_50};
  border-color: ${tokens.SUCCESS_60};
`;

const RemovedTreeDot = styled(LegendDot)`
  background-color: ${tokens.ERROR_40};
  border-color: ${tokens.ERROR_50};
`;

export {
  TreeRemovalLegend,
  TREE_REMOVAL_MESSAGE,
  EXISTING_TREES_LABEL,
  REMOVED_TREES_LABEL,
};
